import { css, useTheme } from '@emotion/react';

const useStyle = () => {
  const theme = useTheme();

  const { primary, background } = theme.palette;
  const { md, sm } = theme.breakpoints;
  const { spacing } = theme;

  const headerWrapper = css`
    display: flex;
    max-width: 1440px;
    width: 100%;
    margin: 0 auto;
    background: ${background.gray3};
    position: relative;

    & > img {
      width: 56%;
      height: auto;
      margin: auto 0;

      @media (max-width: ${`${sm}px`}) {
        width: auto;
        min-height: 265px;
        order: 1;
        object-fit: cover;
      }
    }

    @media (max-width: ${`${sm}px`}) {
      flex-direction: column;
    }
  `;

  const headerContent = css`
    padding: 75px 30px 50px 50px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    & > div {
      width: 100%;
    }

    @media (max-width: ${`${sm}px`}) {
      order: 2;
      padding: ${spacing(2)};
      align-items: center;
    }
  `;

  const headerStyle = css`
    @media (max-width: ${`${sm}px`}) {
      position: absolute;
      top: ${spacing(2)};
      right: ${spacing(2)};
      bottom: ${spacing(2)};
      left: ${spacing(2)};
    }
  `;

  const headerText = css`
    @media (max-width: ${`${400}px`}) {
      font-size: 16px;
      font-weight: 500;
      line-height: 21px;
    }
  `;

  const namedBestStyle = css`
    font-weight: 700;
    font-size: 14px;
    line-height: 18px;
    max-width: 310px;
    margin-top: ${spacing(2)};

    @media (max-width: ${`${sm}px`}) {
      text-align: left;
    }
  `;

  const headerHeading = css`
    margin-bottom: ${spacing(1)};

    @media (max-width: ${`${400}px`}) {
      font-size: 24px;
      line-height: 30px;
    }
  `;

  const headerCta = css`
    margin: ${spacing(4, '0', '0')};
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: ${spacing(1)};
    max-width: 290px;
    width: 100%;

    @media (max-width: ${`${sm}px`}) {
      margin: ${spacing('0', 'auto')};
      width: 100%;
    }
  `;

  const subtextStyle = css`
    font-weight: 400;
    font-size: 14px;
    line-height: 14px;
    color: ${primary.main};
  `;

  const buildMySystemButton = css`
    @media (max-width: ${`${sm}px`}) {
      text-decoration: underline;
    }
  `;

  return {
    headerWrapper,
    headerContent,
    headerHeading,
    headerStyle,
    headerCta,
    subtextStyle,
    namedBestStyle,
    buildMySystemButton,
    headerText,
  };
};

export default useStyle;
